<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津津旅物业管理有限公司</div>
                  <p class="p1">
                    天津津旅物业管理有限公司成立于2007年4月，是市旅游集团投资控股的物业企业，具有物业管理国家二级企业资质。主要经营业务为物业管理、房地产信息咨询服务、商务信息咨询服务、劳务服务、保洁服务、物业管理咨询服务、会议服务等。
                  </p>
                  <div class="p1">
                    公司成立之初，就立足于高起点，聘请北京戴德梁行物业管理有限公司为物业顾问，瞄准高端物业市场，致力于打造一流物业管理团队，经过几年来的不懈努力，形成了一整套严谨科学的管理体系。我们以为业主创造最理想的商住环境和高品位享受为原则，以超前的人文服务和设施服务为目标，以国际化物业管理方式和星级酒店服务标准为工作内容，以超越客户期望为标准，竭诚提供专业化、标准化、人性化的物业管理服务。
                  </div>
                  <div class="p1">
                    “勇于创新、打造品牌”是公司的战略目标；“诚信为本、追求卓越”是公司的企业精神；“激情策划、活力执行”是公司的工作理念；“唯才是举、公平竞争”是公司的人才理念；“安全关爱、和谐高雅”是公司的服务目标；“爱岗敬业、追求完美”是公司的工作标准。
                  </div>
                  <div class="p1">
                    我们在集团党委领导下，坚持“业主至上”的服务理念，千方百计地为业主和承租户创造安全、舒适、便捷的工作生活环境，树立了“津旅物业”品牌的良好形象，取得了较好的经济效益和社会效益。公司所管理的君隆广场项目2011年被评为天津市物业管理优秀大厦。随着我市楼宇经济的大力发展，公司积极走出去，面向市场，拓展项目，努力实现企业做大做强。
                  </div>
                  <div class="img1">
                    <img src="@/assets/images/jlwy.png" alt="" height="450px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>